import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';

const CopiedSnackbar = ({
  open,
  handleClose,
}) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={1200}
      onClose={handleClose}
      message={<span>URL copied</span>}
    />
  );
};

export default CopiedSnackbar;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/Events/CopiedSnackbar/CopiedSnackbar.jsx